import React, { Component } from 'react'
import Container from '../../components/layout/container.component'
import Title from '../../components/typography/title.component'
import { StyledRegulation } from './benefits.styles'

class BenefitsPage extends Component {
	render() {
		const { history } = this.props

		return (
			<Container style={{ paddingBottom: '5rem' }}>
				<Title>
					<span className="bold">Benefícios e Gratuidades</span>
				</Title>
				<StyledRegulation>
					<div>
						<h3>
							<strong>Descontos e Gratuidades para Passageiros</strong>
						</h3>
						<p>
							Com base nas legislações vigentes, apresentamos um resumo
							dos benefícios de descontos e gratuidades disponíveis para
							idosos, portadores de ID Jovem e beneficiários do Passe
							Livre no transporte rodoviário interestadual.
						</p>
						<ul>
							<li>
								<strong>Idosos</strong>
								<ul>
									<li>
										<strong>Gratuidade:</strong> Dois assentos
										gratuitos por ônibus para pessoas idosas com renda
										de até dois salários mínimos, conforme a Lei nº
										10.741/2003 (Estatuto do Idoso) e a Resolução nº
										6.033, de 21 de dezembro de 2023.
									</li>
									<li>
										<strong>Desconto:</strong> Quando esgotadas as
										vagas gratuitas, é garantido um desconto mínimo de
										50% no preço do serviço para idosos com renda de
										até dois salários mínimos, utilizando como
										referência o preço mais baixo praticado pela
										empresa transportadora.
									</li>
								</ul>
							</li>
							<li>
								<strong>ID Jovem</strong>
								<ul>
									<li>
										<strong>Gratuidade:</strong>
										Dois assentos gratuitos por ônibus para jovens de
										baixa renda, titulares da Identidade Jovem, de
										acordo com a Lei nº 12.852/2013 (Estatuto da
										Juventude) e a Resolução nº 6.033, de 21 de
										dezembro de 2023.
									</li>
									<li>
										<strong>Desconto:</strong> Quando esgotadas as
										vagas gratuitas, é garantido dois assentos com um
										desconto mínimo de 50% no preço do serviço,
										utilizando como referência o preço mais baixo
										praticado pela empresa transportadora.
									</li>
								</ul>
							</li>
							<li>
								<strong>Passe Livre</strong>
								<ul>
									<li>
										<strong>Gratuidade:</strong> Vagas gratuitas, sem
										limitação de assentos, para pessoas com
										deficiência, comprovadamente carentes, titulares
										da credencial de Passe Livre, conforme a Lei nº
										8.899/1994 e a Portaria Nº 1.579, de 25 de
										novembro de 2022.
									</li>
									<li>
										<strong>Acompanhante:</strong> A gratuidade se
										estende ao acompanhante do beneficiário quando
										indicado na credencial do Passe Livre.
									</li>
								</ul>
							</li>
							<li>
								Procedimentos para Obtenção dos Benefícios
								<p>
									Para solicitar a gratuidade ou os descontos, 
									para vendas exclusivamente dos trechos da Planalto 
									Transportes da operação Interestadual com a 
									classe Convencional, o beneficiário deve enviar 
									os seguintes documentos:
								</p>
								<ol>
									<li>
										<strong>Pessoa Idosa:</strong>
										<ul>
											<li>
												Documento de identidade com foto e CPF.
											</li>
											<li>
												Comprovante de renda, como Carteira de
												Trabalho, contracheque, carnê do INSS,
												extrato de pagamento de benefício ou
												declaração fornecida pelo INSS, ou carteira
												de assistência social.
											</li>
										</ul>
									</li>
									<li>
										<strong>ID Jovem:</strong>
										<ul>
											<li>
												Documento de identidade com foto e CPF.
											</li>
											<li>
												Carteirinha ID Jovem válida (frente e
												verso).
											</li>
										</ul>
									</li>
									<li>
										<strong>Passe Livre:</strong>
										<ul>
											<li>
												Documento de identidade com foto e CPF.
											</li>
											<li>
												Credencial de Passe Livre válida (frente e
												verso).
											</li>
										</ul>
										<ul>
											<strong>Acompanhante:</strong>
											<li>
												Se o Cartão do Passe Livre constar a
												informação de "necessidade de acompanhante",
												será emitida outra passagem com 100% de
												desconto para o acompanhante e o
												beneficiário não poderá embarcar
												desacompanhado;
											</li>
											<li>
												O acompanhante precisa ser informado para o
												recebimento do benefício; ou seja, o
												beneficiário ao solicitar o cadastro de
												passe livre deverá fornecer os dados do
												acompanhante.
											</li>
										</ul>
									</li>
								</ol>
							</li>
						</ul>
						<p>
							Para obter o bilhete de passagem, um cadastro prévio 
							deverá ser realizado no site www.muviflex.com.br, 
							exclusivamente pelo beneficiário, conforme esclarecimento 
							do Art. 151 da Resolução ANTT nº 6.033, de 21 de dezembro de 2023, 
							e por razões de segurança.
						</p>
						<p>
							Após o cadastro no site Muviflex, a solicitação de desconto ou 
							gratuidade deverá ser feita pelo beneficiário por meio do 
							WhatsApp (55) 4020-7488. O beneficiário deverá enviar 
							um documento de identificação oficial com foto e CPF idêntico 
							ao informado no cadastro do site Muviflex, e o comprovante 
							de elegibilidade do benefício. Além disso, é necessário 
							informar os seguintes dados abaixo::
						</p>
						<ul>
							<li>Nome completo do beneficiário:</li>
							<li>Data de nascimento do beneficiário:</li>
							<li>CPF do Beneficiário:</li>
							<li>Telefone do beneficiário:</li>
							<li>E-mail do beneficiário:</li>
							<li>Tipo de benefício:</li>
							<li>Nome, CPF, Telefone e Data de nascimento do acompanhante (no caso de passe livre, se assim constar na credencial):</li>
						</ul>
						<p>Esses documentos e procedimentos são essenciais para garantir a segurança e a conformidade com as normas vigentes.</p>
						
						<p>Observações se necessário:</p>
						<ul>
							<i>Disponibilidade dos Benefícios</i>
							<li>
								<strong>Disponibilidade:</strong> A concessão dos
								benefícios está sujeita à disponibilidade de assentos na
								viagem, sendo assegurada a reserva dessas vagas até 3
								(três) horas de antecedência em relação ao horário de
								partida do ponto inicial da linha que atende ao trecho
								da viagem solicitada (§ 4º, Art. 149, Resolução nº
								6.033/2023).
							</li>
							<li>
								<strong>Prazo para Solicitação:</strong> Para melhor
								organização e atendimento, se possível, a solicitação
								dos benefícios deve ocorrer com um prazo mínimo de 5
								dias antes da data da viagem.
							</li>
							<li>
								<strong>
									O beneficiário de gratuidades e descontos previstos
									em lei não poderá, ainda que em autoritárias
									diferentes, fazer reserva em mais de um horário para
									o mesmo dia e mesmo destino ou para horários e dias
									cuja realização da viagem se demonstre impraticável e
									caracterize domínio de reserva de lugares, em
									detrimento de outros beneficiários.
								</strong>
							</li>
						</ul>
						<p>
							Para as demais viações que não sejam a Planalto Transportes, 
							Nossos parceiros disponibilizam os seguintes canais:
						</p>
						<ul>
							<li>
								Auto Viação 1001:{' '}
								<a href="https://vendas.jcaholding.com.br/">
									Benefícios e Gratuidades - Auto Viação 1001
								</a>
							</li>
							<li>
								Viação Catarinense:{' '}
								<a href="https://vendas.jcaholding.com.br/">
									Benefícios e Gratuidades - Viação Catarinense
								</a>
							</li>
							<li>
								Viação Cometa:{' '}
								<a href="https://vendas.jcaholding.com.br/">
									Benefícios e Gratuidades - Viação Cometa
								</a>
							</li>
							<li>
								Expresso do Sul:{' '}
								<a href="https://vendas.jcaholding.com.br/">
									Benefícios e Gratuidades - Expresso do Sul
								</a>
							</li>
							<li>
								Rápido Ribeirão Preto:{' '}
								<a href="https://vendas.jcaholding.com.br/">
									Benefícios e Gratuidades - Rápido Ribeirão Preto
								</a>
							</li>
						</ul>
						<p>
							As empresas transportadoras são obrigadas a oferecer esses
							benefícios em todas as rotas interestaduais e em assentos
							da classe convencional, respeitando as disponibilidades e
							regulamentações previstas nas legislações citadas. Para
							mais informações e detalhes, consulte a{' '}
							<a href="https://www.in.gov.br/en/web/dou/-/resolucao-n-6.033-de-21-de-dezembro-de-2023-533478064">
								Resolução nº 6.033, de 21 de dezembro de 2023
							</a>
							.
						</p>
					</div>
				</StyledRegulation>
			</Container>
		)
	}
}

export { BenefitsPage as ModuleRootComponent }
